var map = {
	"./dashboard/items": 470,
	"./dashboard/items.json": 470,
	"./dynamicForms/customerAccountRegistrationBasicForm": 471,
	"./dynamicForms/customerAccountRegistrationBasicForm.json": 471,
	"./images/logo.png": 840,
	"./menu/sidebarmenu": 472,
	"./menu/sidebarmenu.json": 472,
	"./shared/portalConfiguration": 473,
	"./shared/portalConfiguration.json": 473
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 348;